import { queryOptions, useQuery } from '@tanstack/react-query';

import { apiClient } from '@cast/infrastructure-api';

import { useOrganizations } from '@cast/shared-organization-context-data-access';

const APA_INTEGRATION_REPOSITORIES_QUERY_KEY = 'apa-integration-repositories';

const getListRepositoriesQueryKey = (
  organizationId?: string,
  integrationId?: string
) =>
  [
    APA_INTEGRATION_REPOSITORIES_QUERY_KEY,
    organizationId,
    integrationId,
  ] as const;

const getListRepositoriesQueryOptions = ({
  organizationId,
  integrationId,
}: {
  organizationId?: string;
  integrationId?: string;
}) =>
  queryOptions({
    queryKey: getListRepositoriesQueryKey(organizationId, integrationId),
    queryFn: async () => {
      const { data } = await apiClient.apa.listIntegrationRepositories({
        organizationId: organizationId!,
        runbookIntegrationId: integrationId!,
      });
      return data.repositories || [];
    },
    enabled: !!integrationId && !!organizationId,
  });

type UseListRepositoriesQueryParams = {
  integrationId?: string;
};

export const useListRepositoriesQuery = ({
  integrationId,
}: UseListRepositoriesQueryParams) => {
  const { currentOrganization } = useOrganizations();

  const { data, isLoading, error, refetch } = useQuery(
    getListRepositoriesQueryOptions({
      organizationId: currentOrganization?.id,
      integrationId,
    })
  );

  return { repositories: data, isLoading, error, refetch };
};
